/**
 * IntelSources — /agents/intel-sources. The registry list, or one source's detail when `?source=<id>` is present
 * (so a source can be linked, reloaded and reached with browser back). Each view is one page template: ListPage
 * (IntelSourcesList) or DetailPage (SourceDetailPage).
 */
import { useSearchParams } from 'react-router-dom';
import { IntelSourcesList } from './intel-sources/IntelSourcesList.js';
import { SourceDetailPage } from './intel-sources/SourceDetailPage.js';

export default function IntelSourcesPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const requested = Number(searchParams.get('source'));
  const sourceId = Number.isInteger(requested) && requested > 0 ? requested : null;

  if (sourceId !== null) {
    return <SourceDetailPage sourceId={sourceId} onClose={() => setSearchParams({}, { replace: false })} />;
  }

  return <IntelSourcesList onOpen={(id) => setSearchParams({ source: String(id) })} />;
}
